import ErrorState from '@rio-cloud/rio-uikit/ErrorState';
import { FormattedMessage, useIntl } from 'react-intl';

type ErrorFallbackProps = {
    errorMessage?: string;
    onRetry?: () => void;
};

const ErrorFallback = ({ errorMessage, onRetry }: ErrorFallbackProps) => {
    const intl = useIntl();

    return (
        <ErrorState
            outerClassName='margin-top-20'
            headline={intl.formatMessage({
                id: 'intl-msg:common-message.error.generic.headline',
                defaultMessage: 'Oh snap! Something went wrong.',
            })}
            message={
                <>
                    {intl.formatMessage({
                        id: 'intl-msg:common-message.error.generic.message',
                        defaultMessage: 'We could not load your data. Please try again.',
                    })}
                    {errorMessage && <div className='margin-top-15 text-color-dark'>{errorMessage}</div>}
                </>
            }
            buttons={
                onRetry
                    ? [
                          {
                              onClick: onRetry,
                              text: (
                                  <FormattedMessage
                                      id='intl-msg:common-message.error.generic.retry'
                                      defaultMessage='Retry'
                                  />
                              ),
                          },
                      ]
                    : undefined
            }
        />
    );
};

export default ErrorFallback;
